import { customAlphabet } from 'nanoid';
import { getUrl } from '../config/urls';

// Create a custom nanoid generator with a specific alphabet
const nanoid = customAlphabet('abcdefghijklmnopqrstuvwxyz0123456789', 8);

export function generateToken(): string {
  return nanoid();
}

export function generateCSV(prospects: any[]): string {
  // Headers for Emelia.io integration
  const headers = ['First Name', 'Last Name', 'Email', 'Personalized Link'];
  
  const rows = prospects.map(p => [
    p.prenom,
    p.nom,
    p.email,
    `${window.location.origin}${getUrl('', p.token)}`
  ]);

  return [
    headers.join(','),
    ...rows.map(row => row.map(cell => `"${cell}"`).join(','))
  ].join('\n');
}